import { ChangeEvent, useEffect } from "react";
// import { useContrato } from "../../../../../../../context/ContratoContext";
import { useNeg } from "../../../../../../../context/NegContext";
import { ConsultaParametrosData } from "../../../../../../../types/simular-acordo-interface";
import { converterParaNumeroAmericano, converterParaNumeroBrasileiro } from '../../../../../../../utils/convertNumbers'

interface ParametroSimulacaoProps {
  simulacao: ConsultaParametrosData
  tipoNeg: string
}

export const ParametroSimulacao = ({ simulacao, tipoNeg }: ParametroSimulacaoProps) => {
  // const { consultParamentros } = useContrato()
  const { valoresSimulacao, setDescontos, descontos, setValorEntrada, percentualEntrada, setPercentualEntrada } = useNeg()

  useEffect(() => {
    setDescontos({
      percentual_desconto: '0,00',
      percentual_isencaojuros: '0,00',
      percentual_isencaomulta: '0,00',
      percentual_juros_renegociacao: '0,00'
    })
    setValorEntrada('0,00')
    setPercentualEntrada('0')
  }, [tipoNeg])




  // function getInBRL(n: string) {
  //   const numero = converterParaNumeroAmericano(n)
  //   const real = converterParaNumeroBrasileiro(numero)
  //   return real && real !== 'NaN,undefined' ? real : '0,00'
  // }
  // rounded-l-lg

  function getInputName(name: string) {
    if (name === 'percentual_isencaomulta' || name === 'percentual_isencaojuros' || name === 'percentual_desconto') return name
    else return ''
  }

  function handleDescontos(name: string, value: string) {
    const inputName = getInputName(name)
    if (inputName !== '') {
      setDescontos(
        prevState => ({
          ...prevState,
          [name]: value
        })
      )
      const element = document.getElementById(inputName) as HTMLInputElement;

      if (name === 'percentual_isencaomulta') {
        if (Number(value) < converterParaNumeroAmericano(simulacao.regrassimularacordo.percentual_isencaomulta_min) || Number(value) > converterParaNumeroAmericano(simulacao.regrassimularacordo.percentual_isencaomulta_max)) {
          element.style.border = '2px solid red'
          return
        }
        element.style.border = ''
      }
      if (name === 'percentual_isencaojuros') {
        if (Number(value) < converterParaNumeroAmericano(simulacao.regrassimularacordo.percentual_isencaojuros_min) || Number(value) > converterParaNumeroAmericano(simulacao.regrassimularacordo.percentual_isencaojuros_max)) {
          element.style.border = '2px solid red'
          return
        }
        element.style.border = ''
      }

      if (name === 'percentual_desconto') {
        if (Number(value) < converterParaNumeroAmericano(simulacao.regrassimularacordo.percentual_desconto_min) || Number(value) > converterParaNumeroAmericano(simulacao.regrassimularacordo.percentual_desconto_max)) {
          element.style.border = '2px solid red'
          return
        }
        element.style.border = ''
      }

    }
  }

  const handlePercentageChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = parseFloat(event.target.value);
    setPercentualEntrada(event.target.value)
    const element = document.getElementById(event.target.id) as HTMLInputElement;

    if (inputValue < converterParaNumeroAmericano(simulacao.regrassimularacordo.percentual_entrada_min) || inputValue > converterParaNumeroAmericano(simulacao.regrassimularacordo.percentual_entrada_max)) {
      element.style.border = '2px solid red'
      setValorEntrada('Valor incorreto')
      return
    }
    element.style.border = ''
    calculateResult(inputValue);

  };

  const calculateResult = (inputValue: number) => {
    const total = converterParaNumeroAmericano(valoresSimulacao?.valorCorrigido || '0')
    const calculatedResult = (total * inputValue) / 100;
    setValorEntrada(isNaN(calculatedResult) ? '0,00' : converterParaNumeroBrasileiro(Number(calculatedResult.toFixed(2))));
  };



  return (
    <div className="flex items-center justify-center">
      <div className="flex w-[80%] items-center justify-center gap-1 rounded-lg  border px-4 py-2">
        {/* Dados */}
        <div className="w-full">
          {/* <div className="grid-simulacao">
            <p className="p-simulacao"></p>
            <p className="p-simulacao"></p>
            <p className="p-simulacao"></p>
          </div> */}
          <div className="grid-simulacao ">
            <p className="p-simulacao"></p>
            <p className="underline text-primary p-simulacao">Mínimo</p>
            <p className="underline text-primary p-simulacao">Máximo</p>
          </div>
          <div className="grid-simulacao ">
            <p className="p-simulacao">Máximo dias entrada/AV:</p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.dias_primeira_parcela_min}</p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.dias_primeira_parcela_max}</p>
          </div>
          <div className="grid-simulacao">
            <p className="p-simulacao">%Entrada: </p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.percentual_entrada_min}%</p>

            {/* Trocar para input */}
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.percentual_entrada_max}%</p>
          </div>
          <div className="grid-simulacao">
            <p className="p-simulacao">Desconto valor principal: </p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.percentual_desconto_min}%</p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.percentual_desconto_max}%</p>
          </div>
          <div className="grid-simulacao">
            <p className="p-simulacao">Desconto juros por atraso: </p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.percentual_isencaojuros_min}%</p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.percentual_isencaojuros_max}%</p>
          </div>
          <div className="grid-simulacao">
            <p className="p-simulacao">Desconto multa por atraso: </p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.percentual_isencaomulta_min}%</p>
            <p className="p-simulacao-azul">{simulacao?.regrassimularacordo?.percentual_isencaomulta_max}%</p>
          </div>
        </div>

        {/* Dados Min/Max */}

        <div className="w-42 rounded-md bg-gray-200 text-primary">
          <div className="border my-2 px-2">
            <p className="text-sm underline font-medium">Simulação</p>
          </div>
          <div className="border my-2 px-2">
            {/* <input type="number" max={100} min={0} maxLength={3} className="w-[99%] outline-none px-2 mt-0.5 " /> */}
            {/* Max Dias */}
            <p className="text-sm underline px-2 mt-0.5 h-8 font-medium"></p>
          </div>
          <div className="border my-2 px-2">
            {/* Entrada */}
            <input type="number" id="percentual_entrada" value={percentualEntrada} max={Number(simulacao?.regrassimularacordo?.percentual_entrada_max?.replace(',', '.'))} min={0} maxLength={3} className="w-[99%] outline-none px-2  py-0.5 text-sm " onChange={e => handlePercentageChange(e)} disabled={tipoNeg === 'AV'} />
          </div>
          <div className="border my-2 px-2">
            {/* Desc. Valor Principal */}
            <input type="number" value={descontos?.percentual_desconto} max={Number(simulacao?.regrassimularacordo?.percentual_desconto_max?.replace(',', '.'))} min={0} maxLength={3} className="w-[99%] outline-none px-2  py-0.5 text-sm" id="percentual_desconto" onChange={(e) => handleDescontos(e.target.id, e.target.value)} />
          </div>
          <div className="border my-2 px-2">
            {/* Desc. Juros */}
            <input type="number" value={descontos?.percentual_isencaojuros} max={Number(simulacao?.regrassimularacordo?.percentual_isencaojuros_max?.replace(',', '.'))} min={0} maxLength={3} className="w-[99%] outline-none px-2  py-0.5  text-sm" id="percentual_isencaojuros" onChange={(e) => handleDescontos(e.target.id, e.target.value)} />
          </div>
          <div className="border my-2 px-2">
            {/* Desc. Multa */}
            <input type="number" value={descontos?.percentual_isencaomulta} max={Number(simulacao?.regrassimularacordo?.percentual_isencaomulta_max?.replace(',', '.'))} min={0} maxLength={3} className="w-[99%] outline-none px-2  py-0.5 text-sm" id="percentual_isencaomulta" onChange={(e) => handleDescontos(e.target.id, e.target.value)} />
          </div>
          {/* <div className="grid-simulacao-info">
            <p className="underline">Min</p>
            <p className="underline">Max</p>
          </div>

          <div className="grid-simulacao-info">
            <p>{simulacao?.regrassimularacordo?.dias_primeira_parcela_min}</p>
            <p>{simulacao?.regrassimularacordo?.dias_primeira_parcela_max}</p>
          </div>

          <div className="grid-simulacao-info">
            <p>{simulacao?.regrassimularacordo?.percentual_entrada_min}%</p>
            <p>{simulacao?.regrassimularacordo?.percentual_entrada_max}%</p>
          </div>

          <div className="grid-simulacao-info">
            <p>{simulacao?.regrassimularacordo?.percentual_desconto_min}%</p>
            <p>{simulacao?.regrassimularacordo?.percentual_desconto_max}%</p>
          </div>


          <div className="grid-simulacao-info">
            <p>{simulacao?.regrassimularacordo?.percentual_isencaojuros_min}%</p>
            <p>{simulacao?.regrassimularacordo?.percentual_isencaojuros_max}%</p>
          </div>

          <div className="grid-simulacao-info">
            <p>{simulacao?.regrassimularacordo?.percentual_isencaomulta_min}%</p>
            <p>{simulacao?.regrassimularacordo?.percentual_isencaomulta_max}%</p>
          </div> */}
        </div>
      </div>

      {/* Valores da divida */}
      {/* <div className="rounded-r-lg border px-4 py-2 ">
        <div className="grid-divida">
          <p className="text-primary underline">Valores da divida</p>
          <p></p>
        </div>
        <div className="grid-divida">
          <p className="p-simulacao">Valor Original</p>
          <p className="p-simulacao-azul">R$ {valoresSimulacao?.valorOriginal}</p>
        </div>
        <div className="grid-divida">
          <p className="p-simulacao">Juros</p>
          <p className="p-simulacao-azul">R$ {valoresSimulacao?.juros}</p>
        </div>
        <div className="grid-divida">
          <p className="p-simulacao">Multa</p>
          <p className="p-simulacao-azul">R$ {valoresSimulacao?.multa}</p>
        </div>

        <div className="grid-divida">
          <p className="p-simulacao">Corrigido</p>
          <p className="p-simulacao-azul">R$ {valoresSimulacao?.valorCorrigido}</p>
        </div>
        <div className="grid-divida">
          <p className="p-simulacao">Desconto</p>
          <p className="p-simulacao-azul">R$ {getInBRL(simulacao?.regrassimularacordo?.valormaximodesconto)}</p>
        </div>
        <div className="grid-divida">
          <p className="p-simulacao">Total</p>
          <p className="p-simulacao-azul">R$ {valoresSimulacao?.total}</p>
        </div>
      </div> */}
    </div>
  );
};
